module.exports = __webpack_public_path__ + "img/timestudy-11.8e74dc88.png";